import {
  Component, h, Listen, Prop, State, Watch, Event, type EventEmitter
} from '@stencil/core';
import type {UiaasGuided} from '../../guided/uiaas-guided';

@Component({
  tag: 'uiaas-search-voice-record-button',
  styleUrl: 'uiaas-search-voice-record-button.scss',
  shadow: true,
})
export class UiaasSearchVoiceRecordButton {
  @Prop({mutable:true}) beamAnimation: boolean = false;
  @Prop() readonly guidedSearchId : string;
  private wasVoiceSearchPromoted = false;

  @State() term: string;


  @Listen('guided:voiceSearchWasPromoted', { target: 'window' })
  voiceSearchWasPromotedHandler() {
      this.wasVoiceSearchPromoted = true;
      this.beamAnimation = false;
  }

  @Listen('guided:hasFocus', { target: 'window' })
  hasFocusHandler() {
      if (!this.wasVoiceSearchPromoted) {
        this.beamAnimation = true;
      }
  }

  @Listen('guided:hasBlur', { target: 'window' })
  hasBlurHandler() {
      if(!this.wasVoiceSearchPromoted) {
        this.beamAnimation = false;
      }
  }

  @Event({
    eventName: 'guided:voiceSearchMicrophoneClicked',
    composed: true,
    cancelable: true,
    bubbles: true
  }) eventEmittervoiceSearchMicrophoneClicked: EventEmitter;

  private guidedSearch: HTMLElement;

  private handleClick = async () => {
      if (this.guidedSearch) {

        this.term = (document.getElementById('uiaas-search-input') as HTMLInputElement)?.value;

        this.eventEmittervoiceSearchMicrophoneClicked.emit({
          category: this.term ? 'Guided Search' : 'Search_bar',
          action: 'click',
          label: 'target:microphone',
          keyword: this.term
        });
        await (this.guidedSearch as unknown as UiaasGuided).useVoiceSearch();
      }
  };

  componentWillLoad() {
      if(this.guidedSearchId){
        this.guidedSearch = document.getElementById(this.guidedSearchId) as HTMLElement;
      }
      const voiceSearchPromoted = localStorage.getItem('voice_search_promoted');
      this.wasVoiceSearchPromoted = voiceSearchPromoted !== null;
  }

  render() {
      return (
        <div class="uiaas-search-voice__button-wrapper">
          <qds-button
            onClick={this.handleClick}
            class={'uiaas-search-voice__record-button'}
            size="medium"
            importance="subdued"
            icon-library="default"
            icon-only="true"
            icon-name="microphone">
          </qds-button>
          {this.beamAnimation &&
            <div class="uiaas-search-voice__animation-wrapper">
              <div class={'uiaas-search-voice__animation-circle-1'}></div>
              <div class={'uiaas-search-voice__animation-circle-2'}></div>
              <div class={'uiaas-search-voice__animation-circle-3'}></div>
            </div>
          }
        </div>
      );
  }
}

